module.exports = __webpack_public_path__ + "media/images/simulation/ic_pdf-b1ceb1cc817ed586e7b0b78013ffb115.svg";